import React from "react"
import axios from "axios"
import { deserialise } from "kitsu-core"
import { Comment, Icon, Tooltip, Avatar, message, Button } from "antd"

import { getAuthorization } from "api"
import * as AuthHelper from "helpers/auth.helper"

import Lightbox from "components/common/Lightbox/Index"
import MiniPlayer from "components/common/MiniPlayer/Index"
import Editor from "components/common/CommetBox/Editor"

import "./Index.css"

class CommentBox extends React.Component {
  state = {
    likedComments: [],
    replyToCommentId: null,
    submitting: false,
    resetEditor: false,
  }

  handleLike = ({ doubtMessageId, likedByCurrentUser }) => {
    const userType = AuthHelper.getUserType()

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/api/${userType}s/doubt_messages/${doubtMessageId}/toggle_like`,
        {},
        {
          headers: {
            Authorization: getAuthorization(),
            "Content-Type": "multipart/form-data",
          },
        },
      )
      .then(async (response) => {
        const responseData = response.data

        if (!responseData["doubt"]) {
          message.destroy()
          message.error("Couldn't like message.")
          this.setState({ submitting: false })
          return
        }

        const deserialisedData = await deserialise(responseData["doubt"])

        this.props.updateStore(deserialisedData.data.doubt_messages)

        if (!likedByCurrentUser) {
          message.destroy()
          message.success("You liked the comment.")
        }
      })
      .catch((e) => {
        console.error("Error", e)
        this.setState({
          submiting: false,
        })
        message.destroy()
        message.error("Couldn't like message.")
      })
  }

  handleReplyTo = (commentId) => {
    const { replyToCommentId } = this.state

    if (replyToCommentId === commentId) {
      this.setState({ replyToCommentId: null })
      return
    }
    this.setState({ replyToCommentId: commentId })
  }

  componentDidMount() {}

  attachActions = ({ commentId, totalLikes, hideReplyTo = false, likedByCurrentUser }) => {
    const actions = [
      <span key="like">
        <Tooltip title={likedByCurrentUser ? "Dislike" : "Like"}>
          <Icon
            type="like"
            theme={likedByCurrentUser ? "filled" : "outlined"}
            onClick={() => this.handleLike({ doubtMessageId: commentId, likedByCurrentUser })}
          />
        </Tooltip>
        <span style={{ paddingLeft: 8, cursor: "auto" }}>{totalLikes || null}</span>
      </span>,
    ]

    if (!hideReplyTo) {
      actions.push(
        <span key="reply-to" onClick={() => this.handleReplyTo(commentId)}>
          Reply
        </span>,
      )
    }

    return actions
  }

  handleAddComment = (commentData) => {
    const { msg, fileList } = commentData
    const { doubt } = this.props
    const formData = new FormData()

    this.setState({ submitting: true })

    formData.append("message", msg)
    formData.append("doubt_id", doubt.id)

    if (commentData.commentId) {
      formData.append("doubt_message_id", commentData.commentId)
    }

    fileList.forEach((file) => {
      formData.append("files[]", file)
    })

    const userType = AuthHelper.getUserType()

    if (!["student", "teacher"].includes(userType)) {
      message.destroy()
      message.error("You are not allowed to comment")
      this.setState({ submitting: false })
      return
    }

    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/${userType}s/doubts/${doubt.id}/doubt_messages`, formData, {
        headers: {
          Authorization: getAuthorization(),
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (response) => {
        const responseData = response.data

        if (!responseData["doubt"]) {
          message.destroy()
          message.error("Failed to add message")
          this.setState({ submitting: false })
          return
        }

        const deserialisedData = await deserialise(responseData["doubt"])

        this.props.updateStore(deserialisedData.data.doubt_messages)

        message.destroy()
        message.success("Your comment is submitted successfully.")
        this.setState({ submitting: false, resetEditor: true })
      })
      .catch((e) => {
        console.error("Error", e)
        this.setState({
          submiting: false,
        })
        message.destroy()
        message.error("Couldn't add message.")
      })
  }

  renderAttachments = (attachedFiles) => {
    const images = attachedFiles.filter((f) => f.contentType.includes("image"))

    const audios = attachedFiles.filter((f) => f.contentType.includes("audio"))

    return (
      <div style={{ display: "flex" }}>
        <Lightbox images={images} />
        <MiniPlayer audios={audios} />
      </div>
    )
  }

  handleResetEditorDone = () => {
    this.setState({ resetEditor: false })
  }

  renderMainReplyToButton = () => {
    const { replyToCommentId } = this.state
    const { commentable } = this.props

    if (!commentable) return null
    if (!replyToCommentId) return null

    const divStyle = {
      marginTop: 25,
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
    }

    return (
      <div style={divStyle}>
        <Button type="primary" onClick={() => this.setState({ replyToCommentId: null })}>
          Reply in main thread
        </Button>
      </div>
    )
  }

  renderComments = ({ comments, currentUser }) => {
    const { replyToCommentId, submitting, resetEditor } = this.state
    const { commentable } = this.props

    const commentsList = comments.map((c) => {
      return (
        <div className={`comment-item ${c.user.user_type}-comment`} key={`comment-${c.id}`}>
          <Comment
            actions={this.attachActions({
              hideReplyTo: false,
              commentId: c.id,
              totalLikes: c.likes ? c.likes.length : 0,
              likedByCurrentUser: c.likes.filter((l) => parseInt(l.liker.id) === parseInt(currentUser.id)).length > 0,
            })}
            author={<span>{c.user.email}</span>}
            avatar={<Avatar icon="user" />}
            content={
              <div>
                {c.parent && (
                  <div className="blockquote">
                    <div className="comment-from">{c.parent.user.email}</div>
                    <p>{c.parent.message}</p>
                  </div>
                )}
                <p>{c.message}</p>
                <div>{this.renderAttachments(c.attached_files)}</div>
              </div>
            }
            // datetime={
            //   <Tooltip title={moment().format("YYYY-MM-DD HH:mm:ss")}>
            //     <span>{moment().fromNow()}</span>
            //   </Tooltip>
            // }
          />
          {c.children &&
            c.children.map((cc) => {
              if (!cc.message) return null

              return (
                <div key={`comment-${cc.id}`}>
                  <Comment
                    actions={this.attachActions({
                      commentId: cc.id,
                      totalLikes: cc.likes ? cc.likes.length : 0,
                      likedByCurrentUser: cc.likes.filter((u) => u.id === currentUser.id).length > 0,
                    })}
                    author={<span style={{ textTransform: "capitalize" }}>{cc.user.user_type}</span>}
                    avatar={<Avatar icon="user" />}
                    content={
                      <div>
                        <p>{cc.message}</p>
                        <div>{this.renderAttachments(cc.attached_files)}</div>
                      </div>
                    }
                    // datetime={
                    //   <Tooltip title={moment().format("YYYY-MM-DD HH:mm:ss")}>
                    //     <span>{moment().fromNow()}</span>
                    //   </Tooltip>
                    // }
                  />
                </div>
              )
            })}

          {replyToCommentId === c.id && commentable && (
            <Editor
              resetEditor={resetEditor}
              commentId={c.id}
              onResetEditorDone={this.handleResetEditorDone}
              onAddComment={this.handleAddComment}
              submitting={submitting}
            />
          )}
        </div>
      )
    })

    return (
      <div className="comment-list">
        {commentsList}
        {this.renderMainReplyToButton()}
        {!replyToCommentId && commentable && (
          <Editor
            resetEditor={resetEditor}
            onResetEditorDone={this.handleResetEditorDone}
            onAddComment={this.handleAddComment}
            submitting={submitting}
          />
        )}
      </div>
    )
  }

  render() {
    const { doubt, currentUser } = this.props

    return (
      <div className="comments-wrapper">{this.renderComments({ comments: doubt.doubt_messages, currentUser })}</div>
    )
  }
}

export default CommentBox
